<template>
  <div class="view">
    <decorate></decorate>
    <div class="main homepage">
      <div class="nav" :style="scrollNav">
        <div class="left" @click="closeApp()">
          <div class="front icon_back"></div>
        </div>
        金币商城
        <router-link
          class="record"
          :to="{
            path: '/record',
            query: {
              userId: userId,
              uid: queryData.uid,
              appId: queryData.appId,
              TopHeight: queryData.TopHeight,
              apptype: queryData.apptype,
              isRn: queryData.isRn == '1' ? '1' : '0',
            },
          }"
          >兑换记录</router-link
        >
      </div>
      <Scrapper class="scroll" ref="view" :style="scrollMain">
        <div class="user">
          <img
            v-if="homePage.userInfo.userHeadImg == ''"
            class="no_name"
            src="../assets/images/no_name.png"
            alt
          />
          <van-image
            v-else
            class="avator"
            round
            :src="homePage.userInfo.userHeadImg"
          />
          <div class="info">
            <p class="big">{{ homePage.userInfo.userName }}</p>
            <div class="small">
              金币：{{
                homePage.userInfo.itemList &&
                homePage.userInfo.itemList.gold_key
              }}
            </div>
          </div>
          <div class="edit">
            <div class="front icon_edit"></div>
            <router-link
              :to="{
                path: '/selfInfo',
                //name: 'selfInfo',
                //params: { statusTab: 1 },
                query: {
                  userId: userId,
                  uid: queryData.uid,
                  appId: queryData.appId,
                  TopHeight: queryData.TopHeight,
                  apptype: queryData.apptype,
                  isRn: queryData.isRn == '1' ? '1' : '0',
                },
              }"
              >编辑</router-link
            >
          </div>
        </div>
        <div class="banner" v-if="Object.keys(bannerPs).length == 1">
          <a
            class="banner_img_one"
            :href="item.url"
            target="_blank"
            v-for="(item, index) in bannerPs"
            :key="index"
          >
            <img class="item" :src="item.img" alt />
          </a>
        </div>
        <div class="banner" v-else>
          <div class="swiper-container" id="swiper1">
            <swiper
              :options="swiperOption"
              v-if="Object.keys(bannerPs).length > 0"
            >
              <swiper-slide
                class="swiper-slide"
                v-for="(item, index) in bannerPs"
                :key="index"
              >
                <a :href="item.url" target="_blank">
                  <img :src="item.img" alt />
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="tab">
          <p class="p" :class="{ active: idx == 1 }" @click="idx = 1">
            精选商品
          </p>
          <p class="p" :class="{ active: idx == 2 }" @click="idx = 2">
            全部商品
          </p>
        </div>
        <div class="list" v-show="idx == 1">
          <div
            v-if="
              homePage.chosenList.goodsInfo !== undefined &&
              homePage.chosenList.goodsInfo.length > 0
            "
            v-for="(item, index) in homePage.chosenList.goodsInfo"
            :key="index"
            class="item"
            @click="checkItems(item)"
          >
            <div class="img_re">
              <van-image class="post" contain :src="item.img" />
              <p
                v-if="
                  item.is_discount_yn == 1 &&
                  (item.is_vip_discount_yn == 2 || item.is_vip_discount_yn == 1)
                "
              >
                {{ item.attribute_discount_json.title }}
              </p>
            </div>
            <div class="info">
              <div v-if="item.is_purchase_limit == 1">
                <p v-if="item.purchase_limit_type == 1" class="limited">
                  限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 2" class="limited">
                  每天限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 3" class="limited">
                  每周限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 4" class="limited">
                  每月限购数量：{{ item.purchase_limit_number }}
                </p>
              </div>
              <p class="name">{{ item.title }}</p>
              <div class="zkxx">
                <!-- <p
                  class="original_price"
                  v-for="(a, d) in item.priceInfo"
                  :key="d"
                  v-if="item.attribute_discount_json.price <= 0"
                >
                  原价：{{ a.amount }}
                </p> -->
                <p
                  class="original_price"
                  v-for="(a, d) in item.priceInfo"
                  :key="d"
                  v-if="
                    item.is_discount_yn == 1 &&
                    (item.is_vip_discount_yn == 2 ||
                      item.is_vip_discount_yn == 1)
                  "
                >
                  原价：{{ a.amount }}
                </p>
                <p
                  class="discount"
                  v-if="
                    item.is_discount_yn == 1 &&
                    (item.is_vip_discount_yn == 2 ||
                      item.is_vip_discount_yn == 1)
                  "
                >
                  折后：{{
                    item.attribute_discount_json.price > 0
                      ? item.attribute_discount_json.price
                      : item.discountPriceInfo[0].amount
                  }}
                </p>
                <p
                  class="vip_title"
                  v-if="
                    item.is_discount_yn == 2 && item.is_vip_discount_yn == 1
                  "
                >
                  会员特权折扣
                </p>
                <p
                  class="vip_title"
                  v-if="
                    item.is_discount_yn == 1 && item.is_vip_discount_yn == 1
                  "
                >
                  会员折上折
                </p>
              </div>
              <div
                class="time"
                v-if="
                  item.attribute_discount_json.etime != '' &&
                  item.is_discount_yn == 1 &&
                  (item.is_vip_discount_yn == 2 || item.is_vip_discount_yn == 1)
                "
              >
                <p>距结束仅剩：</p>
                <div class="time-bg">
                  <span>{{ item.attribute_discount_json.timer.hour }}</span> 时
                  <span>{{ item.attribute_discount_json.timer.min }}</span> 分
                  <span>{{ item.attribute_discount_json.timer.sec }}</span> 秒
                </div>
                <!-- <div>{{ timerTotel }}</div> -->
              </div>
              <div class="left">
                <p class="big" v-for="(a, d) in item.priceInfo" :key="d">
                  金币：{{ a.amount }}
                </p>
                <p class="small">库存：{{ item.limit_stock }}</p>
              </div>
              <!-- <div v-if="item.exchange_type == 3" class="right">折现</div> -->
              <div v-if="item.exchange_type == 2" class="right">物流</div>
            </div>
          </div>
          <div
            class="img_alt"
            v-if="
              homePage.chosenList.goodsInfo !== undefined &&
              homePage.chosenList.goodsInfo.length < 0
            "
          >
            <img src="../assets/images/no_shop.png" alt />
            <p>没有相关物品</p>
          </div>
        </div>
        <div class="list" v-show="idx == 2">
          <div
            v-if="
              homePage.productList.goodsInfo !== undefined &&
              homePage.productList.goodsInfo.length > 0
            "
            v-for="(item, index) in homePage.productList.goodsInfo"
            :key="index"
            class="item"
            @click="checkItems(item)"
          >
            <div class="img_re">
              <van-image class="post" contain :src="item.img" />
              <p
                v-if="
                  item.is_discount_yn == 1 &&
                  (item.is_vip_discount_yn == 2 || item.is_vip_discount_yn == 1)
                "
              >
                {{ item.attribute_discount_json.title }}
              </p>
            </div>
            <div class="info">
              <div v-if="item.is_purchase_limit == 1">
                <p v-if="item.purchase_limit_type == 1" class="limited">
                  限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 2" class="limited">
                  每天限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 3" class="limited">
                  每周限购数量：{{ item.purchase_limit_number }}
                </p>
                <p v-if="item.purchase_limit_type == 4" class="limited">
                  每月限购数量：{{ item.purchase_limit_number }}
                </p>
              </div>
              <p class="name">{{ item.title }}</p>
              <div class="zkxx">
                <!-- <p
                  class="original_price"
                  v-for="(a, d) in item.priceInfo"
                  :key="d"
                  v-if="item.attribute_discount_json.price <= 0"
                >
                  原价：{{ a.amount }}
                </p> -->
                <p
                  class="original_price"
                  v-for="(a, d) in item.priceInfo"
                  :key="d"
                  v-if="
                    item.is_discount_yn == 1 &&
                    (item.is_vip_discount_yn == 2 ||
                      item.is_vip_discount_yn == 1)
                  "
                >
                  原价：{{ a.amount }}
                </p>
                <p
                  class="discount"
                  v-if="
                    item.is_discount_yn == 1 &&
                    (item.is_vip_discount_yn == 2 ||
                      item.is_vip_discount_yn == 1)
                  "
                >
                  折后：{{
                    item.attribute_discount_json.price > 0
                      ? item.attribute_discount_json.price
                      : item.discountPriceInfo[0].amount
                  }}
                </p>
                <p
                  class="vip_title"
                  v-if="
                    item.is_discount_yn == 2 && item.is_vip_discount_yn == 1
                  "
                >
                  会员特权折扣
                </p>
                <p
                  class="vip_title"
                  v-if="
                    item.is_discount_yn == 1 && item.is_vip_discount_yn == 1
                  "
                >
                  会员折上折
                </p>
              </div>
              <div
                class="time"
                v-if="
                  item.attribute_discount_json.etime != '' &&
                  item.is_discount_yn == 1 &&
                  (item.is_vip_discount_yn == 2 || item.is_vip_discount_yn == 1)
                "
              >
                <p>距结束仅剩：</p>
                <div class="time-bg">
                  <span>{{ item.attribute_discount_json.timer.hour }}</span> 时
                  <span>{{ item.attribute_discount_json.timer.min }}</span> 分
                  <span>{{ item.attribute_discount_json.timer.sec }}</span> 秒
                </div>
                <!-- <div>{{ timerTotel }}</div> -->
              </div>
              <div class="left">
                <p class="big" v-for="(a, d) in item.priceInfo" :key="d">
                  金币：{{ a.amount }}
                </p>
                <p class="small">库存：{{ item.limit_stock }}</p>
              </div>
              <div v-if="item.exchange_type == 3" class="right">折现</div>
              <div v-if="item.exchange_type == 2" class="right">物流</div>
            </div>
          </div>
          <div
            v-if="
              homePage.productList.goodsInfo !== undefined &&
              homePage.productList.goodsInfo.length < 0
            "
            class="img_alt"
          >
            <img src="../assets/images/no_shop.png" alt />
            <p>没有相关物品</p>
          </div>
        </div>
      </Scrapper>

      <!-- 商品简介弹窗 -->
      <!-- <div class="Introduction_mask_bg" v-if="detailMask">
        <div class="Introduction_mask">
          <div class="conter_banner" v-if="detaildec.imgShow">
            <van-swipe :autoplay="3000">
              <van-swipe-item
                v-for="(item, index) in detaildec.imgShow"
                :key="index"
              >
                <a :href="item.url" target="_blank">
                <img :src="item" alt />
                </a>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="dunction_text">
            <p class="text-color">
              消耗金币：{{ detaildec.priceInfo[0].amount }}
            </p>
            <p class="text-dec">{{ detaildec.title }}</p>
          </div>
          <div class="dec-xs" v-if="detaildec.details">
            <p>
           {{detaildec.details}}
          </p>
            <div v-html="textW"></div>
          </div>
          <div class="btn-mask">
            <div class="btn-close" @click="detailMask = false"></div>
            <div class="btn-color" @click="goodsby(detaildec)"></div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import sa from "sa-sdk-javascript";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Scrapper from "./element/Scrapper";
import decorate from "./element/decorate";
import "../css/home.scss";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  components: { Scrapper, decorate },
  data: function () {
    return {
      hour: "",
      min: "",
      sec: "",
      // 倒计时多少秒
      timetemp: 3620,
      detailMask: false,
      userId: "",
      bannerPs: {},
      topHeight: 0,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true, // 无限循环
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 6,
        loopAdditionalSlides: 2,
      },
      listPattern: false,
      scrollY: true,
      idx: 1,
      statusId: "",
      detaildec: "",
      textW: "",
      device: "",
      timerList: [],
    };
  },
  watch: {
    "homePage.chosenList.goodsInfo"() {
      for (const i in this.homePage.chosenList.goodsInfo) {
        if (
          this.homePage.chosenList.goodsInfo[i].attribute_discount_json.etime ==
          ""
        ) {
          continue;
        }
        let { is_discount_yn, is_vip_discount_yn } =
          this.homePage.chosenList.goodsInfo[i];

        if (
          is_discount_yn == 1 &&
          (is_vip_discount_yn == 2 || is_vip_discount_yn == 1)
        ) {
          this.homePage.chosenList.goodsInfo[i].attribute_discount_json.timer =
            this.timerTotel(
              new Date(
                this.homePage.chosenList.goodsInfo[
                  i
                ].attribute_discount_json.etime.replace(/-/g, "/")
              )
            );
          let timer = setInterval(() => {
            this.homePage.chosenList.goodsInfo[
              i
            ].attribute_discount_json.timer = this.timerTotel(
              new Date(
                this.homePage.chosenList.goodsInfo[
                  i
                ].attribute_discount_json.etime.replace(/-/g, "/")
              )
            );
            let { hour, min, sec } =
              this.homePage.chosenList.goodsInfo[i].attribute_discount_json
                .timer;
            // console.log(hour,min,sec);
            if (hour <= 0 && min <= 0 && sec <= 0) {
              this.homePage.chosenList.goodsInfo[
                i
              ].attribute_discount_json.etime = "";
              clearInterval(timer);
            }
            this.$forceUpdate();
          }, 1000);
          this.timerList.push(timer);
        }
      }
    },
    "homePage.productList.goodsInfo"() {
      for (const i in this.homePage.productList.goodsInfo) {
        if (
          this.homePage.productList.goodsInfo[i].attribute_discount_json
            .etime == ""
        ) {
          continue;
        }

        this.homePage.productList.goodsInfo[i].attribute_discount_json.timer =
          this.timerTotel(
            new Date(
              this.homePage.productList.goodsInfo[
                i
              ].attribute_discount_json.etime.replace(/-/g, "/")
            )
          );
        let timer = setInterval(() => {
          this.homePage.productList.goodsInfo[i].attribute_discount_json.timer =
            this.timerTotel(
              new Date(
                this.homePage.productList.goodsInfo[
                  i
                ].attribute_discount_json.etime.replace(/-/g, "/")
              )
            );
          this.$forceUpdate();
        }, 1000);
        this.timerList.push(timer);
      }
    },
  },
  destroyed() {
    for (const el of this.timerList) {
      clearInterval(el);
    }
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapGetters([]),
    scrollNav() {
      return {
        backgroundColor: `rgba(254,210,0,${(this.scrollY / 65) * -1})`,
      };
    },
    scrollMain() {
      return {
        backgroundColor: `rgba(255,255,255,${(this.scrollY / 65) * -1})`,
      };
    },
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations("homePage", ["setSyssetting"]),
    // 转换成时分秒a
    timerTotel(endDate = new Date()) {
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
      // console.log(endDate)
      // endDate = endDate.replace(/-/g, "/")
      var end = endDate.getTime();
      let time = end - now;
      // .replace(/-/g, "/")
      let h = Math.floor(time / 1000 / 60 / 60);
      let m = Math.floor((time / 1000 / 60) % 60);
      let s = Math.floor((time / 1000) % 60);
      if (h < 10 && h >= 0) {
        h = "0" + h;
      }
      if (m < 10 && m >= 0) {
        m = "0" + m;
      }
      if (s < 10 && s >= 0) {
        s = "0" + s;
      }
      return { hour: h, min: m, sec: s };
    },
    checkItems(item) {
      if (this.homePage.userInfo.limit == 0) {
        Toast("该ID已被限制，不能兑换商品");
      } else {
        let query = {
          userId: this.userId,
          uid: this.queryData.uid,
          TopHeight: this.queryData.TopHeight,
          apptype: this.queryData.apptype,
          goodsId: item.id,
          appId: this.queryData.appId,
          addresssId: this.queryData.addresssId,
          bankId: this.queryData.bankId,
          alipayId: this.queryData.alipayId,
        };

        if (this.queryData.isRn == "1") {
          query.isRn = "1";
        }
        this.$router.push({
          path: "/prodetails",
          // name: "Prodetails",
          query,
        });
      }
    },
    //返回APP
    closeApp() {
      if (window && window.parent) {
        window.parent.postMessage(
          {
            type: "goBack",
          },
          "*"
        );
      }
      if (window && window.postMessage && this.$route.query.isRn == 1) {
        window.postMessage(
          JSON.stringify({
            type: "returnback",
          })
        );
      }
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.returnback.postMessage({});
      }

      if (window.AndroidClient) {
        window.AndroidClient.backToHome();
      }
    },
  },
  created() {
    // console.log(this.homePage.chosenList.goodsInfo)
    // this.openTimer();
    this.$store.dispatch("homePage/fetchSyssetting").then((res) => {
      this.statusId = res.data[1][0].value;
      console.log(this.statusId);
    });
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    // console.log(this.topHeight);
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      this.device = 1;
    } else {
      this.device = 3;
    }
  },
  mounted() {
    let obj = {
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    let bannerId = {
      position_id: 1,
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    this.$store.dispatch("homePage/fetchUserUid", obj).then((res) => {
      this.userId = res.data.id;
      let oobj = {
        userId: this.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
        pageSize: 99,
      };
      let objc = {
        userId: this.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
        pageSize: 99,
        device: this.device,
      };
      let jx = {
        userId: this.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
        is_chosen: 1,
        pageSize: 99,
        device: this.device,
      };
      this.$store.dispatch("homePage/fetchHome", oobj);
      this.$store.dispatch("homePage/fetchProductList", objc);
      this.$store.dispatch("homePage/fetchChosenList", jx);
      this.$store.dispatch("homePage/fetchAddressList", oobj);
      this.$store.dispatch("homePage/fetchBankList", oobj);
      this.$store.dispatch("homePage/fetchAlipayList", oobj);
    });
    this.$store.dispatch("homePage/fetchAllbanner", bannerId).then((res) => {
      this.bannerPs = res.data;
    });
    const self = this;
    this.$refs.view.scroll.on("scroll", (position) => {
      self.scrollY = position.y;
    });
  },
};
</script>
